var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.show,"timeout":_vm.timeout,"color":"primary","outlined":""},on:{"input":_vm.closeSnackbar},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.closeSnackbar}},'v-btn',attrs,false),[_vm._v("Close")])]}}])},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }